export default __webpack_public_path__ + "static/media/successPlanImg.faff0727.png";